import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table,
} from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  createSchoolPerformance,
  getSchoolPerformanceStudentForBatch,
} from "../../actions/SchoolPerformance.action";
import { years } from "../../constants/MonthsAndYears";
import {
  getTermCountOptions,
  getTermLabel,
  getTermOptions,
} from "../../utils/coachingPerformance";
import styles from "../AddCoachingPerformanceForm/AddCoachingPerformanceForm.module.css";

const isValidTotalMark = (value) => {
  const parsedValue = parseFloat(value);
  return Number.isFinite(parsedValue) && parsedValue > 0;
};

const isValidGainedMark = (value) => {
  const parsedValue = parseFloat(value);
  return Number.isFinite(parsedValue) && parsedValue >= 0;
};

const AddSchoolPerformanceForm = ({
  grades,
  getSchoolPerformanceStudentForBatch,
  createSchoolPerformance,
}) => {
  const [grade, setGrade] = useState("");
  const [batch, setBatch] = useState("");
  const [shift, setShift] = useState("");
  const [termCount, setTermCount] = useState("");
  const [term, setTerm] = useState("");
  const [total, setTotal] = useState("100");
  const [totalShow, setTotalShow] = useState("100");
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState(null);

  const updateStudentField = (studentId, field, value) => {
    setStudents(
      students.map((student) =>
        student.id === studentId
          ? {
              ...student,
              [field]: value,
            }
          : student
      )
    );
  };

  const selectHandeler = async () => {
    if (!isValidTotalMark(total)) {
      toast.error("Please enter total mark!");
      return;
    }
    if (!termCount) {
      toast.error("Please select term count!");
      return;
    }
    if (!term) {
      toast.error("Please select term type!");
      return;
    }
    const list = await getSchoolPerformanceStudentForBatch(
      year,
      term,
      batch,
      termCount
    );
    if (!list) {
      return;
    }
    setStudents(
      list.map((l) => ({
        total,
        gained: "0",
        id: l.id,
        studentId: l.id,
        uid: l.uid,
        name: l.name,
        phone: l.phone,
      }))
    );
    setTotalShow(total);
  };

  const submitHandeler = async () => {
    if (!students || students.length === 0) {
      toast.error("Please select at least one student!");
      return;
    }

    const invalidStudent = students.find(
      (student) =>
        !isValidTotalMark(student.total) || !isValidGainedMark(student.gained)
    );

    if (invalidStudent) {
      toast.error(
        `Please enter valid total and gained marks for ${invalidStudent.name}.`
      );
      return;
    }

    const normalizedStudents = students.map((student) => ({
      ...student,
      total: parseFloat(student.total),
      gained: parseFloat(student.gained),
    }));

    setLoading(true);
    const check = await createSchoolPerformance(term, year, normalizedStudents);
    if (check === true) {
      setStudents(null);
    }
    setLoading(false);
  };

  const deleteHandeler = (id) => {
    setStudents([...students.filter((st) => st.id !== id)]);
  };

  const termOptions = termCount ? getTermOptions(parseInt(termCount)) : [];

  return (
    <Container>
      <Card bg="white" text="dark" className={`crd shadow`}>
        <Card.Body>
          <Row>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="grade" className="d-block">
                  Class
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setBatch("");
                  setShift("");
                  setGrade(e.target.value);
                }}
              >
                <option value={""}>Select Class</option>
                {grades &&
                  grades.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            {grade !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="shift" className="d-block">
                    Shift
                  </label>
                </div>
                <Form.Select
                  onChange={(e) => {
                    setBatch("");
                    setShift(e.target.value);
                  }}
                >
                  <option value={""}>Select Shift</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .shifts.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" && shift !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="batch" className="d-block">
                    Batch
                  </label>
                </div>
                <Form.Select onChange={(e) => setBatch(e.target.value)}>
                  <option value={""}>Select Batch</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .batches.filter((bt) => bt.shiftId === parseInt(shift))
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" && shift !== "" && batch !== "" && total ? (
              <Col
                md={3}
                className="d-flex jsutify-content-end align-items-end py-3"
              >
                <Button
                  onClick={selectHandeler}
                  variant="primary"
                  type="submit"
                  className="btn_primary"
                >
                  Select
                </Button>
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="termCount" className="d-block">
                  Term Count
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setTermCount(e.target.value);
                  setTerm("");
                }}
                id="termCount"
                name="termCount"
                value={termCount}
              >
                <option value={""}>Select Term Count</option>
                {getTermCountOptions().map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="term" className="d-block">
                  Term Type
                </label>
              </div>
              <Form.Select
                onChange={(e) => setTerm(e.target.value)}
                id="term"
                name="term"
                value={term}
              >
                <option value={""}>Select Term Type</option>
                {termOptions.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="year" className="d-block">
                  Year
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setYear(e.target.value);
                }}
                id="year"
                name="year"
                value={year}
              >
                {years.map((item, i) => (
                  <option key={i} value={`${item}`}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="total" className="d-block">
                  Total Mark
                </label>
              </div>
              <Form.Control
                onChange={(e) => setTotal(e.target.value)}
                value={total}
                type="number"
                id="total"
                name="total"
              />
            </Col>
          </Row>

          {students && (
            <div className={styles.tbl_wrapper}>
              <h5 className="pt-4 pb-2">
                {getTermLabel(parseInt(termCount), parseInt(term))} - {year}
              </h5>
              <Table bordered responsive striped>
                <thead>
                  <tr>
                    <th>UID</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Total</th>
                    <th>Gained</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student) => (
                    <tr key={student.id}>
                      <td>{student.uid}</td>
                      <td>{student.name}</td>
                      <td>{student.phone}</td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            type="number"
                            value={student.total}
                            onChange={(e) =>
                              updateStudentField(
                                student.id,
                                "total",
                                e.target.value
                              )
                            }
                          />
                        </InputGroup>
                      </td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            type="number"
                            value={student.gained}
                            onChange={(e) =>
                              updateStudentField(
                                student.id,
                                "gained",
                                e.target.value
                              )
                            }
                          />
                        </InputGroup>
                      </td>
                      <td className="text-center">
                        <span
                          className={styles.delete_btn}
                          onClick={() => deleteHandeler(student.id)}
                        >
                          <BiTrash />
                        </span>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={6}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Total Mark Template: {totalShow}</span>
                        <Button
                          onClick={submitHandeler}
                          variant="primary"
                          className="btn_primary"
                          disabled={loading}
                        >
                          {loading ? "Loading..." : "Submit"}
                        </Button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default connect(null, {
  createSchoolPerformance,
  getSchoolPerformanceStudentForBatch,
})(AddSchoolPerformanceForm);
